module.exports = __webpack_public_path__ + "img/item_Character_fluid_01c.3740d012.jpeg";